<div class="main-container">

    <div class = "form" *ngIf = "(dynamicForm)">
        <app-dynamic-form
          [formGroup] = "formGroup"
          [formConfig] = "dynamicForm"
        >
        </app-dynamic-form>
    </div>

    <app-static-table
    [tableMeta]="serviceTableMeta"
    [(data)]="serviceList"
    [showCheckBox]="false"
    [editAllowed]="true"
    [readOnlyMode]="readonly"
    [noDataFoundMsg]="'No service added'"
    (dataChange)="onServiceListChange($event)"
    (onEditRecord)="editService($event)"
    ></app-static-table>
    
</div>